// extracted by mini-css-extract-plugin
module.exports = {"c_button":"ControlButton_c_button__3m2-S"};